import { MobileHeader } from 'components/eventView/layout/MobileHeader';
import { PageHeader } from 'components/eventView/layout/PageHeader';
import { EventViewOverviewPageContent } from 'components/eventView/pages/EVOverviewPageContent';
import { EventDescription } from 'components/guide/banner/EventDescription';
import { StickyHeaderContentLayout } from 'elements/eventView/layout/StickyHeaderContentLayout';
import { StickyHeaderLayout } from 'elements/eventView/layout/StickyHeaderLayout';
import { motion } from 'framer-motion';
import { EVDetailPageMobile } from 'pages/EventViewPage/EventViewPageMobile/EVDetailPageMobile';
import { useContext, useEffect } from 'react';
import { Route, Routes } from 'react-router';
import { CtxEventView } from 'session/ctxEventView';
import styled, { css } from 'styled-components/macro';

interface Props {
    className?: string;
}

export const EVOverviewPageMobile = (props: Props) => {
    const ctxEventView = useContext(CtxEventView);

    useEffect(() => {
        const scrollListener = () => {
            const scrollPosition = document.getElementById('scrollmobilelanding')?.scrollTop;
            localStorage.setItem('scrollPosition', scrollPosition.toString());
        };
        document.getElementById('scrollmobilelanding')?.addEventListener('scroll', scrollListener);

        return () => {
            document
                .getElementById('scrollmobilelanding')
                ?.removeEventListener('scroll', scrollListener);
        };
    }, []);

    if (!ctxEventView) {
        return null;
    }

    const { eventData } = ctxEventView;
    const { eventInfo } = eventData;

    return (
        <S_EVOverviewPageMobile
            className={props.className}
            $bgImage={ctxEventView.eventData?.eventInfo?.homepageTopImageUrl ?? null}
        >
            <StickyHeaderLayout>
                <S_MobileHeader $isFixed={!ctxEventView.isPreview} />
            </StickyHeaderLayout>
            <S_StickyHeaderContentLayout headerHeight={64}>
                <S_PageHeader />
                {eventInfo.description && <S_EventDescription text={eventInfo.description} />}
                <S_EventViewOverviewPageContent $margin={!eventInfo.description} />
            </S_StickyHeaderContentLayout>
            <Routes location={location} key={location.pathname}>
                <Route path=":detailId" element={<S_EVDetailPageMobile />} />
            </Routes>
        </S_EVOverviewPageMobile>
    );
};

const S_EVOverviewPageMobile = styled(motion.div)<{ $bgImage: string | null }>`
    padding: 0 0 80px 0;
    ${(props) =>
        props.$bgImage &&
        css`
            background-image: url(${props.$bgImage});
            background-position: top center;
            background-size: contain;
            background-repeat: no-repeat;
        `}
`;

const S_EVDetailPageMobile = styled(EVDetailPageMobile)``;

const S_MobileHeader = styled(MobileHeader)<{ $isFixed: boolean }>`
    /* position: ${(props) => (props.$isFixed ? 'fixed' : 'absolute')};
    z-index: ${(props) => (props.$isFixed ? '100' : 'auto')};
    top: 0; */
    width: 100%;
    box-shadow: 9.002px 9.002px 45.012px 0px rgba(0, 0, 0, 0.1);
    z-index: 1;
`;

const S_PageHeader = styled(PageHeader)`
    margin: 50px 0 0 0;
`;

const S_EventDescription = styled(EventDescription)`
    margin: 54px 0 0 0;
`;

const S_StickyHeaderContentLayout = styled(StickyHeaderContentLayout)`
    margin: 0 20px 100px 20px;
`;

const S_EventViewOverviewPageContent = styled(EventViewOverviewPageContent)<{ $margin: boolean }>`
    padding: 0 0 100px 0;
    ${(props) => {
        if (props.$margin) {
            return css`
                margin: 54px 0 0 0;
            `;
        } else {
            return css`
                margin: 15px 0 0 0;
            `;
        }
    }}
`;
